import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=65e4b4b2&lang=pug&"
import script from "./ContactSection.vue?vue&type=script&lang=js&"
export * from "./ContactSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports